import { ApiCollectionResponse, GetCollectionQueryParams } from '../../types';
import { ReadBuyer } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { GetBuyersFilter } from '../../endpoints/buyers';

export const getBuyers = async (
  params: GetCollectionQueryParams<ReadBuyer, GetBuyersFilter>,
): Promise<ApiCollectionResponse<ReadBuyer>> => {
  return await tinctApi.buyers.getBuyers(params);
};

export const useGetBuyers = (
  params: GetCollectionQueryParams<ReadBuyer, GetBuyersFilter>,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<ReadBuyer>, ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    queryKey: ['buyers', params],
    queryFn: () => getBuyers(params),
    ...options,
  });
